import { Link } from 'react-router-dom'

/**
 * Gerüst für die statischen Rechtsseiten (Impressum/Datenschutz/AVV). Öffentlich (ohne Login), erreichbar
 * über den Login-Fuß. Bewusst NUR die Hülle: der rechtsverbindliche Text kommt von Simon (Firmendaten,
 * §-Texte) — daher hier kein erfundener Inhalt, sondern ein ehrlicher Hinweis statt Platzhalter-Juristerei.
 */
export function LegalPage({ title }: { title: string }) {
  return (
    <main className="wf-legal">
      <article className="wf-legal__doc">
        <h1 className="wf-legal__title">{title}</h1>
        <p className="wf-legal__note">Diese Seite wird derzeit erstellt — der vollständige Text folgt in Kürze.</p>
        <Link to="/login" className="wf-btn wf-btn--ghost">
          Zurück zur Anmeldung
        </Link>
      </article>
    </main>
  )
}
